"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionObserverManager = void 0;
class IntersectionObserverManager {
    static createObserver(elements, callback, options = { threshold: 0.1 }) {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        callback(entry, obs);
                        obs.unobserve(entry.target); // Unobserve after first intersection
                    }
                });
            }, options);
            elements.forEach(element => observer.observe(element));
        }
    }
    static observeElements() {
        // Observe video title box
        const videoTitleBox = document.querySelector('.imagegroup__titleBox');
        if (videoTitleBox) {
            this.createObserver(document.querySelectorAll('.imagegroup__titleBox'), entry => entry.target.classList.add('add__transform'));
        }
        // Observe elements that animate upwards
        const animatedUp = document.querySelectorAll('.animate__up');
        if (animatedUp.length) {
            this.createObserver(animatedUp, entry => entry.target.classList.add('add__transform__opacity'));
        }
        // Observe character cards for rotation effect
        const characterCards = document.querySelectorAll('.card');
        if (characterCards.length) {
            this.createObserver(characterCards, entry => entry.target.classList.add('add__rotate'));
        }
        // Observe elements to the side
        const animateLeft = document.querySelectorAll('.animate__left');
        if (animateLeft.length) {
            this.createObserver(animateLeft, entry => entry.target.classList.add('add__transform__side'));
        }
        const animateRight = document.querySelectorAll('.animate__right');
        if (animateRight.length) {
            this.createObserver(animateRight, entry => entry.target.classList.add('add__transform__side'));
        }
    }
}
exports.IntersectionObserverManager = IntersectionObserverManager;
